import { render } from "./Sidebar.vue?vue&type=template&id=faeeadd8&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=faeeadd8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faeeadd8"]])

export default __exports__